import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import Icon from 'sharedComponents/Icon';
import { Box, Link, Typography } from '@material-ui/core';

import { GET_ENUMS } from 'const/router';
import Avatar from 'sharedComponents/Avatar';

import { appRoutes } from 'routes';
import useStyles from './useStyles';

const DesktopMenu = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { menuItems } = props;
  const { pathname } = useLocation();

  return (
    <Box className={classes.root}>
      <Link to={appRoutes.rootPath} component={RouterLink}>
        <Icon name="logo" width="100" />
      </Link>
      <Box className={classes.menuItems}>
        {menuItems.map(({ label, name, path, isActive }) => {
          return (
            <Link
              key={name}
              to={path}
              component={RouterLink}
              className={clsx(classes.menuItem, { [classes.menuItemActive]: isActive })}
            >
              <Typography variant="h2">{t(label)}</Typography>
            </Link>
          );
        })}
      </Box>
      <Box className={classes.rightBar}>
        <Link
          to={{ pathname, search: `?popup=${GET_ENUMS.popup.login}` }}
          component={RouterLink}
          className={classes.loginLink}
        >
          {t('layouts.NonAuthLayout.Menu.login')}
        </Link>
        <Avatar />
      </Box>
    </Box>
  );
};

DesktopMenu.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default DesktopMenu;



// WEBPACK FOOTER //
// ./src/layouts/NonAuthLayout/components/Menu/components/DesktopMenu/DesktopMenu.js